import { useContext } from "react";

import { type EditModeValue, editModeContext } from "./edit-mode-context";

export function useEditModeMaybe(): EditModeValue | null {
  return useContext(editModeContext);
}
